import { TimepubHTMLRangeObject, HTMLRange } from '../types';

// ============================================================================
// Helper Functions
// ============================================================================

/**
 * Converts a Timepub HTML range object to our internal HTMLRange format
 */
export function formatHtmlRange(htmlString: TimepubHTMLRangeObject): HTMLRange {
  return {
    range: {
      startBlockIndex: htmlString.range.start,
      endBlockIndex: htmlString.range.end,
    },
    htmlString: htmlString.htmlString,
  } as HTMLRange;
}

// ============================================================================
// API Functions
// ============================================================================

export async function fetchHTMLRange(
  id: string,
  blockIndex: number,
  authToken?: string,
): Promise<Response> {
  return fetch(`${import.meta.env.VITE_API_URL}/books/${id}/content`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(authToken && {
        Authorization: `Bearer ${authToken}`,
      }),
    },
    body: JSON.stringify({ blockIndex }),
  });
}

export async function getHTMLRangeIndex(
  id: string,
  blockId: number,
  authToken?: string,
): Promise<HTMLRange> {
  const response = await fetchHTMLRange(id, blockId, authToken);
  const json = await response.json();
  return formatHtmlRange(json);
}
